import React from 'react';
import { Icon as DSIcon, IconName, IconSize } from '@/components/shared';
import { IconComponentProps } from './register';

type IconProps = IconComponentProps<IconName, IconSize>;

/**
 * CMS Icon component, using shared Icon component
 */
export const Icon: React.FunctionComponent<IconProps> = ({ icon, size }) => <DSIcon name={icon} size={size} />;
